'use client';

import React from 'react';
import { Modal, ModalProps } from './Modal';
import { DialogHeader } from './DialogHeader';
import { DialogBody } from './DialogBody';
import { DialogFooter } from './DialogFooter';
import { Button } from '../Button';

export type ConfirmDialogProps = Omit<ModalProps, 'children'> & {
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'secondary' | 'tertiary' | 'danger';
  loading?: boolean;
  onConfirm: () => void;
};

export function ConfirmDialog({
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  loading = false,
  onConfirm,
  onClose,
  ...modalProps
}: ConfirmDialogProps) {
  const headerId = 'confirm-dialog-title';
  const bodyId = description ? 'confirm-dialog-body' : undefined;

  return (
    <Modal
      {...modalProps}
      onClose={onClose}
      labelledBy={headerId}
      describedBy={bodyId}
      role="alertdialog"
    >
      <DialogHeader id={headerId} title={title} />
      {description && (
        <DialogBody>
          <div
            id={bodyId}
            style={{ color: 'var(--ds-muted, #4b5563)', fontSize: '0.875rem' }}
          >
            {description}
          </div>
        </DialogBody>
      )}
      <DialogFooter align="end">
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
          {confirmLabel}
        </Button>
      </DialogFooter>
    </Modal>
  );
}
